<template lang="pug">
  v-layout(row wrap)
    v-flex.header-acct(xs12)
      title-section(text="Integrations")
        template(slot='icon')
          v-icon.mr-2(color="black") extension
    v-flex.mb-3(xs12)
      title-section(text="Marketplace" type="subtitle" hash="marketplace")
    v-flex(xs12)
      v-layout(row wrap)
        v-flex(xs12)
        v-layout.ml-2.card-content(row, wrap)
          addon-card(:properties='integrations.marketplace.cma')
            template(slot='icon')
              v-img.mb-2.mt-2(src="/static/img/cloud-cma-logo.png" height="34" contain)            

          addon-card(:properties="integrations.marketplace.zipForm")
            template(slot='icon')
              v-img.mb-2.mt-2(src="/static/img/lw-zipform-logo.svg" height="40" contain)            

          addon-card(:properties='integrations.marketplace.transactionDesk')
            template(slot='icon', color='primary')
              v-img.mb-2.mt-2(src="/static/img/lw-td-logo.png" height="40" contain)

    v-flex.mb-3(xs12)
      title-section(text="Featured Integrators" type="subtitle" hash="featured-integrators")

    v-flex(xs12)
      v-layout(row wrap)
        v-layout.ml-2(xs4 row wrap)
          addon-card(v-for='integrator in integrations.integrators'
            :key='integrator.id'
            :properties='integrator'
            @buttonAction="openNewPage"
            height=""
            )
            template(slot='icon')
              v-img.mb-2.mt-2(:src='integrator.logo' height="40" contain)

    v-flex.mb-3(xs12)
      title-section(text="3er Party Services" type="subtitle" hash="3rd-party")

    v-flex.ml-2.mb-5(xs12)
      v-layout(row wrap)
        v-flex(xs12)
          v-card
            v-data-table(
              data-cy="3rdServices"
              disable-initial-sort            
              :headers="integrations.vendorServices.headers"
              :items="integrations.vendorServices.data"
              hide-actions
            )
              template(slot="items" slot-scope="props")
                td {{ props.item.service }}
                td {{ props.item.key }}
                td
                  v-switch.float-right(
                    data-cy="toggle-service"
                    color="primary"
                  )
            v-layout.pagination
              v-flex.pages
                v-pagination(
                  v-if="paginationPageCount(integrations.vendorServices.data.length, pageSize) > 1"
                  v-model="paginationPage"
                  :length="paginationPageCount(integrations.vendorServices.data.length, pageSize)"
                  total-visible="7"
                  )

              v-flex.limits
                pagination-limit.mr-4(
                  :limits="paginationLimits"
                  :current-limit="pageSize"
                )
</template>
<script>
import AddonCard from './AddonCard';
import TitleSection from './TitleSection';
import Pagination from '@/Core/mixins/pagination';
import PaginationLimit from '@/Core/components/PaginationLimit';
import { INTEGRATIONS } from '../config'

export default {
  name: 'Integrations',
  components: {
    AddonCard,
    TitleSection,
    PaginationLimit,
  },
  mixins: [Pagination],
  data() {
    return {
      integrations: INTEGRATIONS,
      pageSize: 10,
    }
  },
  methods: {
    openNewPage(properties) {
      window.open(properties.redirectUrl, '_blank');
    },
  }
}
</script>
<style scoped>
</style>
